import cache from './portal-cache'
import file from './file'
import subcontent from './subcontent'
import attachment from './attachment'
import role from './role' //권한추가

export default { cache, file, subcontent, attachment, role  } //role 추가

